var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_531_428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_531_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.175 14.425H12C12.2128 14.425 12.391 14.3532 12.5346 14.2096C12.6782 14.066 12.75 13.8878 12.75 13.675V11.1H14.575C14.7878 11.1 14.966 11.0282 15.1096 10.8846C15.2532 10.741 15.325 10.5628 15.325 10.35V7.74995H17C17.2128 7.74995 17.391 7.67816 17.5346 7.53458C17.6782 7.39099 17.75 7.21279 17.75 6.99998C17.75 6.78716 17.6782 6.60896 17.5346 6.46538C17.391 6.32179 17.2128 6.25 17 6.25H14.575C14.3622 6.25 14.184 6.32179 14.0404 6.46538C13.8968 6.60896 13.825 6.78716 13.825 6.99998V9.575H12C11.7872 9.575 11.609 9.64679 11.4654 9.79038C11.3218 9.93396 11.25 10.1122 11.25 10.325V12.9H9.42498C9.21216 12.9 9.03396 12.9718 8.89038 13.1154C8.74679 13.259 8.675 13.4372 8.675 13.65V16.25H6.99998C6.78716 16.25 6.60896 16.3218 6.46537 16.4654C6.32179 16.609 6.25 16.7872 6.25 17C6.25 17.2128 6.32179 17.391 6.46537 17.5346C6.60896 17.6782 6.78716 17.75 6.99998 17.75H9.42498C9.63779 17.75 9.81599 17.6782 9.95958 17.5346C10.1032 17.391 10.175 17.2128 10.175 17V14.425ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairIcon);
export default __webpack_public_path__ + "static/media/StairIcon.b06c4060a4e50b9f3e4f71f6b1c3fd8d.svg";
export { ForwardRef as ReactComponent };